import { render, staticRenderFns } from "./teamDirectoryDetail.vue?vue&type=template&id=5fd4a068&scoped=true&"
import script from "./teamDirectoryDetail.vue?vue&type=script&lang=js&"
export * from "./teamDirectoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./teamDirectoryDetail.vue?vue&type=style&index=0&id=5fd4a068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd4a068",
  null
  
)

export default component.exports